import Step2 from './Step2'

export default Step2
